/**
 * Vilax Footer — shadows VLT Footer to render only the footer slot.
 *
 * VLT's original Footer renders three slots: preFooter, footer, postFooter.
 * Vilax needs only the footer slot (where VilaxFooter is registered).
 * Shadowing eliminates the empty preFooter and postFooter containers.
 *
 * DR-2026-055.
 */
import { useSelector, shallowEqual } from 'react-redux';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';

const Footer = () => {
  const content = useSelector(
    (state) => state.content.data,
    shallowEqual,
  );

  return (
    <footer id="footer">
      <SlotRenderer name="footer" content={content} />
    </footer>
  );
};

export default Footer;
